"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_router_dom_1 = require("react-router-dom");
const PlaceholderEmptyNotifications_1 = require("../assets/PlaceholderEmptyNotifications");
const PlaceholderEmptyNotificationsFiltersApplied_1 = require("../assets/PlaceholderEmptyNotificationsFiltersApplied");
const PresentInViewPortContextProvider_1 = require("../hooks/PresentInViewPortContextProvider");
const useBulkNotificationStatusUpdate_1 = require("../hooks/useBulkNotificationStatusUpdate");
const translations_1 = require("../types/translations");
const Notificationitem_1 = require("./Notificationitem");
const NotificationPlaceholder_1 = require("./NotificationPlaceholder");
const useStyles = (0, silhouette_core_1.makeStyles)({
    emptyIcon: {
        width: 91,
        height: 120,
    },
    emptyFiltersIcon: {
        width: 136,
        height: 120,
    },
});
const NotificationList = ({ list, selectedNotification, onSelectNotification, identifier, isFiltersApplied, }) => {
    const updateNotifications = (0, useBulkNotificationStatusUpdate_1.useBulkNotificationStatusUpdate)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const classes = useStyles();
    const history = (0, react_router_dom_1.useHistory)();
    if (!list.length) {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { mt: 10, children: isFiltersApplied ? ((0, jsx_runtime_1.jsx)(NotificationPlaceholder_1.NotificationPlaceholder, { icon: (0, jsx_runtime_1.jsx)(PlaceholderEmptyNotificationsFiltersApplied_1.PlaceholderEmptyNotificationsFiltersApplied, { className: classes.emptyFiltersIcon }), title: translate(translations_1.notificationsListTranslations.emptyFilterResults), description: translate(translations_1.notificationsListTranslations.emptyFilterResultsDescription) })) : ((0, jsx_runtime_1.jsx)(NotificationPlaceholder_1.NotificationPlaceholder, { icon: (0, jsx_runtime_1.jsx)(PlaceholderEmptyNotifications_1.PlaceholderEmptyNotifications, { className: classes.emptyIcon }), title: translate(translations_1.notificationsListTranslations.emptyResults), description: translate(translations_1.notificationsListTranslations.emptyResultsDescription) })) }));
    }
    return ((0, jsx_runtime_1.jsx)(PresentInViewPortContextProvider_1.PresentInViewPortContextProvider, { onEnteringViewPort: updateNotifications, children: list.map((userNotification) => {
            return ((0, jsx_runtime_1.jsx)(Notificationitem_1.NotificationItem, { selected: userNotification.id === selectedNotification?.id, userNotification: userNotification, setSelectedNotification: () => {
                    history.push(`/notification-center/${userNotification.id}`);
                    onSelectNotification?.();
                }, identifier: identifier }, userNotification.id));
        }) }));
};
exports.NotificationList = NotificationList;
//# sourceMappingURL=NotificationList.js.map